module.exports = __webpack_public_path__ + "img/2.71e88f85.jpg";